function compareTimes(time1: string, time2: string) {
	const [hours1, minutes1] = time1.split(':').map(Number);
	const [hours2, minutes2] = time2.split(':').map(Number);

	if (hours1 === hours2) {
		return minutes1 - minutes2;
	}
	return hours1 - hours2;
}

export function sortAvailableTimes(timeList: string[]) {
	return timeList.toSorted(compareTimes);
}
